<template>
  <div class="message-list">
    <c-table
      ref="table"
      :columns="columns"
      url="/message/list"
      :fetchPage="true"
    >
    <el-table-column slot="url" label="链接">
        <template v-slot="{row}">
          <a :href="row.url.replace('https://wow.zaobang.com/','')" target="_blank" class="el-button--text">点击跳转链接</a>
        </template>
      </el-table-column>
      <el-table-column slot="unread" label="状态" width="100">
        <template v-slot="{row}">
          <span>{{row.unread===0?'已读':'未读'}}</span>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  name: 'staff-basic',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      columns: [
        { prop: 'content', label: '消息内容' },
        { slot: 'url' },
        { slot: 'unread' }
      ]
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
